import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

//UAT

const firebaseConfig = {
  apiKey: "AIzaSyD7kJ2HEquZH-Oq31mv7FnVpjXb4OP30B8",
  authDomain: "winner-agency.firebaseapp.com",
  databaseURL: "https://winner-agency-default-rtdb.firebaseio.com",
  projectId: "winner-agency",
  storageBucket: "winner-agency.firebasestorage.app",
  messagingSenderId: "29313505497",
  appId: "1:29313505497:web:4bfdd24fc994c42a4d06c8",
  measurementId: "G-N0JPWBWS0H",
};

//SIT

// const firebaseConfig = {
//   apiKey: "AIzaSyBJMvZ73_m6xOqWrDAjqWvFYURnHFDWYO8",
//   authDomain: "winner-sit.firebaseapp.com",
//   databaseURL: "https://winner-sit-default-rtdb.firebaseio.com",
//   projectId: "winner-sit",
//   storageBucket: "winner-sit.firebasestorage.app",
//   messagingSenderId: "516923221790",
//   appId: "1:516923221790:web:241ecbcad96913015ccb0f",
//   measurementId: "G-813NCD10TM",
// };

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
